// extracted by mini-css-extract-plugin
export default {"tech":"HW14_tech__4KLlA","loading":"HW14_loading__OedCv"};